// Helpers for fitting rendered Audio Description / dubbing audio to its
// event's duration using post-render playback speed.

import voiceUtils from "@cclib/providers/textToSpeechAll/voiceUtils.js";
import { WEB_SPEECH_PROVIDER } from "@app/lib/audio/webSpeechTts.js";

export function eventDuration(event) {
    if (!event || isNaN(event.start) || isNaN(event.end) || event.start === false || event.end === false) return 0;
    return Math.max(0, event.end - event.start);
}

/**
 * Playback speed needed so the rendered audio (at speed 1) no longer overruns
 * the event. Only speeds up; audio shorter than the event stays at 1.
 *
 * @param {object} event
 * @returns {number}
 */
export function computeResidualSpeed(event) {
    const duration = eventDuration(event);
    const audioDuration = Number(event?.audioFileDuration) || 0;
    if (duration <= 0 || audioDuration <= duration) return 1;

    const speed = Math.ceil((audioDuration / duration) * 100) / 100;
    return Math.min(voiceUtils.SPEED_LIMITS.max, speed);
}

/**
 * Whether an event can be fitted at all (has timing, text and a renderable voice).
 *
 * @param {object} event
 * @returns {boolean}
 */
export function canFitEvent(event) {
    if (!event?.voice || event.voice.name === "Manual Record") return false;
    if (event.voice.provider === WEB_SPEECH_PROVIDER) return false;
    return eventDuration(event) > 0;
}
